import {GET_ORDERS, GET_ORDER, GET_ORDER_TOKEN, GET_ORDER_ERR, POST_PAY_CREDIT, POST_PAY_CREDIT_ERR, POST_ORDER_STATUS, POST_ORDER_STATUS_ERR} from '../actions/order/type';

const initState = {orders: [], orderErr: null, order: null, count: 0, payCredit: null, payCreditErr: null};
export default function(state = initState, action) {
    switch(action.type) {
        case GET_ORDERS: 
            return {...state, orders: action.payload.data, count: action.payload.count};
        case GET_ORDER_ERR:
            return {...state, order: null, orderErr: action.payload}
        case GET_ORDER: 
            return {...state, order: action.payload}
        case GET_ORDER_TOKEN:
            return {...state, order: action.payload}
        case POST_PAY_CREDIT:
            return {...state, payCredit: action.payload, redirect_url: action.authen_url};
        case POST_PAY_CREDIT_ERR:
            return {...state, payCredit: false, payCreditErr: action.payload};
        case POST_ORDER_STATUS:
            return {...state, setOrderStatus: action.payload}
        case POST_ORDER_STATUS_ERR:
            return {...state, setOrderStatus: false}
        default:
            return {...state}
    }
}